import R from 'ramda'
const {
  getStartFuelCodeAtStartupCost,
  getFuelCodeInfo,
  getPFuelCodeAtFuelCosts,
  getPFuelCodeAtOtherCosts,
  retrieveOaConstraintsPFuelCodes,
  geFuelCodeByFuelCostsTable,
} = require('api/pgads')
const { DOM_CLIENT, WEE_CLIENT, NRG_CLIENT } = require('client')

export const getFinalData = (
  context = {},
  whatIf = false,
  isEventPlanner = false,
  // eslint-disable-next-line no-unused-vars
  trueup = false
) => {
  return (
    (whatIf
      ? context.WFRetrieveData
      : isEventPlanner
      ? context.eventPlanningData
      : context.retrievedData) || {}
  )
}

export const getStartFuelCodeAtStartupCostByClients = ({
  targetInfo,
  CLIENT,
  setError,
  setStartFuelCodeMap,
}) => {
  if (CLIENT === DOM_CLIENT || CLIENT === WEE_CLIENT || CLIENT === NRG_CLIENT) {
    getFuelCodeInfo(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d.code, d.description]))
      setStartFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
    })
  } else {
    getStartFuelCodeAtStartupCost(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d, d]))
      // setStartFuelCodeMap(sFuelCodeMap)
      setStartFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
    })
  }
}

export const getPFuelCodeAtFuelUsageByClients = ({
  targetInfo,
  CLIENT,
  setError,
  setPFuelCodeMap,
}) => {
  if (CLIENT === DOM_CLIENT || CLIENT === WEE_CLIENT || CLIENT === NRG_CLIENT) {
    getFuelCodeInfo(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d.code, d.description]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
    })
  } else {
    getPFuelCodeAtFuelCosts(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d, d]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
      // setPFuelCodeMap(sFuelCodeMap)
    })
  }
}

export const getPFuelCodeAtFuelCosteByClients = ({
  targetInfo,
  CLIENT,
  setError,
  setPFuelCodeMap,
}) => {
  if (CLIENT === DOM_CLIENT || CLIENT === WEE_CLIENT || CLIENT === NRG_CLIENT) {
    getFuelCodeInfo(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d.code, d.description]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
    })
  } else {
    geFuelCodeByFuelCostsTable(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d, d]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
      // setPFuelCodeMap(sFuelCodeMap)
    })
  }
}

export const getPFuelCodeForOtherCostByClients = ({
  targetInfo,
  CLIENT,
  setError,
  setPFuelCodeMap,
}) => {
  if (CLIENT === DOM_CLIENT || CLIENT === WEE_CLIENT || CLIENT === NRG_CLIENT) {
    getFuelCodeInfo(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d.code, d.description]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
    })
  } else {
    getPFuelCodeAtOtherCosts(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d, d]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
      // setPFuelCodeMap(sFuelCodeMap)
    })
  }
}

export const getPFuelCodeForConstraintsByClients = ({
  targetInfo,
  CLIENT,
  setError,
  setPFuelCodeMap,
}) => {
  if (CLIENT === DOM_CLIENT || CLIENT === WEE_CLIENT || CLIENT === NRG_CLIENT) {
    getFuelCodeInfo(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d.code, d.description]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
    })
  } else {
    retrieveOaConstraintsPFuelCodes(targetInfo).fork(setError, data => {
      const sFuelCodeMap = R.fromPairs(data.map(d => [d, d]))
      setPFuelCodeMap({ ...sFuelCodeMap, NA: 'NA' })
      // setPFuelCodeMap(sFuelCodeMap)
    })
  }
}
